import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import '../stylings/PublicDisclosure.css';

const fallbackData = {
  schoolName: 'Akash Model Sr. Sec. School',
  affiliationNo: '[PLACEHOLDER]',
  schoolCode: '[PLACEHOLDER]',
  address: 'Baljeet Vihar, Nithari Extn. Near Rohini Sec-22, New Delhi-110086',
  principalName: 'Geeta Rani',
  contactNo: '9999355051, 9211101997',
  email: 'akashmodelschool5051@gmail.com',
  website: 'www.akashmodelschool.in',
  status: 'Senior Secondary (XI-XII)',
  medium: 'English',
  type: 'Co-Educational',
};

export default function PublicDisclosure() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(process.env.REACT_APP_PUBLIC_DISCLOSURE_API)
      .then((res) => setData(res.data || fallbackData))
      .catch(() => setData(fallbackData))
      .finally(() => setLoading(false));
  }, []);

  const info = data || fallbackData;

  return (
    <Layout bannerTitle="Public Disclosure">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="Public Disclosure" />
          {loading ? (
            <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
          ) : (
            <div className="disclosure-wrapper mt-4">
              <h5 className="disclosure-section-heading">A. General Information</h5>
              <div className="table-responsive">
                <table className="table table-bordered disclosure-table">
                  <tbody>
                    {[
                      ['School Name', info.schoolName],
                      ['Affiliation No.', info.affiliationNo],
                      ['School Code', info.schoolCode],
                      ['Address', info.address],
                      ['Principal Name', info.principalName],
                      ['Contact No.', info.contactNo],
                      ['Email', info.email],
                      ['Website', info.website],
                      ['School Status', info.status],
                      ['Medium of Instruction', info.medium],
                      ['Type', info.type],
                    ].map(([label, value], i) => (
                      <tr key={i}>
                        <td className="disclosure-label">{label}</td>
                        <td>{value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="disclosure-pdf-section mt-4">
                <h5 className="disclosure-section-heading">B. Documents</h5>
                <p className="text-muted">Download the following documents for complete public disclosure.</p>
                <div className="row g-3">
                  {[
                    'Affiliation Certificate',
                    'Trust/Society Registration',
                    'NOC from State Govt.',
                    'Recognition Certificate',
                    'Building Safety Certificate',
                    'Fire Safety Certificate',
                    'DEO Certificate',
                  ].map((doc, i) => (
                    <div key={i} className="col-md-4">
                      <div className="doc-card">
                        <i className="fas fa-file-pdf doc-icon"></i>
                        <span>{doc}</span>
                        <button className="doc-download-btn" disabled>[PLACEHOLDER PDF]</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
